function setSearchParams(newParams = {}, override = false) {
  const {
    search, protocol, host, pathname,
  } = window.location;
  const current = override ? {} : search;
  const params = new URLSearchParams(current);
  const keys = Object.keys(newParams);
  keys.forEach(param => params.set(param, newParams[param]));
  const { title } = window;
  const url = `${protocol}//${host}${pathname}?${params.toString()}`;
  window.history.pushState({ path: url }, title, url);
}

function getSearchParams() {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const query = {};
  params.forEach((value, key) => {
    query[key] = value;
  });
  const totalKeys = Object.keys(query).length;
  return totalKeys > 0 && query;
}

function getId() {
  const { pathname } = window.location;
  return pathname.substring(pathname.lastIndexOf('/') + 1);
}

export default {
  setSearchParams,
  getSearchParams,
  getId,
};
